import React from 'react';
import tenantConstants from '@constants';
import { LinkWithIcon } from '../../../../components/common';
import { IconSwitch } from '../../../../components/svg';
import { useTranslation } from 'react-i18next';
import { getClassifiedBaseURL } from '../../../../utility/env';
import { useSelector } from 'react-redux';
import { getLocaleForURL } from '../../../../utility/language';

const HeaderLink = ({ className }) => {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.app.AppConfig.locale);
  return (
    <LinkWithIcon
      as="a"
      icon={<IconSwitch />}
      linkTitle={t('Go to {{link}}', { link: tenantConstants.LINK_TITLE })}
      href={`${getClassifiedBaseURL()}${getLocaleForURL()}`}
      className={'btnLink px-8 ' + className}
      target="_blank"
    />
  );
};

export default HeaderLink;
